import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Context } from "../.."

import { StorageKey } from "../../constants"
import { prevent } from "../../utils"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import { message } from "antd"
import { LoadingOutlined } from "@ant-design/icons"

import styles3 from "../../styles/Loyalty/LoyaltyOrders.module.scss"
import styles2 from "../../styles/Loyalty/LoyaltyStore.module.scss"
import styles from "../../styles/Footer.module.scss"
import ExcludedModal from "../modals/ExcludedModal"
import RulesModal from "../modals/RulesModal"
import SupportModal from "../modals/SupportModal"
import BlurModal from "./modals/BlurModal"
import MobileAppModal from "../modals/MobileAppModal"
import { ApiService } from "../../api/old_api"

const LoyaltyFooter: FC = () => {

  const { store, loyaltyStore } = useContext(Context)
  const location = useLocation()

  const { width } = useWindowDimensions()

  const [pcLoading, setPCLoading] = useState(false)

  // const _activateCode = async () => {
  //   setPCLoading(prev => prev = true)

  //   const res = await ApiService.loyalty.promos.activatePromoCode({
  //     code: "",
  //     user_id: store.userData.id
  //   })

  //   console.log("activatePromoCode()", res.data)

  //   setPCLoading(prev => prev = false)

  //   if (res.data.state == 0) {
  //     message.error(res.data.message)
  //     return
  //   }

  //   message.success("Промокод успешно применен!")

  //   setTimeout(() => {
  //     window.location.reload()
  //   }, 2000)
  // }

  const setupLocale = (locale: string) => {
    store.setLocale(locale)
    localStorage.setItem(StorageKey.LOCALE, locale)
  }

  useEffect(() => {
    
  }, [])
  
  return (
    location.pathname == "/techworks" ? <></> : <>
      <div className={styles.section_footer} id="footer" style={{opacity: store.isAuth ? "1" : "1"}}>
        <div className="container">
          <div className="row">
            
            <div className="col-12">
              <div className={styles.copys}>
                <div className="row">
                  <div className="col-12 col-md-5">
                    <div className={styles.copys_links}>
                      <a target="_blank" href="/support" onClick={(ev) => {
                        prevent(ev)
                        loyaltyStore.setIsSupportVisible(true)
                      }}>Поддержка</a>
                      <a href="#" onClick={(ev) => {
                        prevent(ev)
                        loyaltyStore.setProjectReviewVisible(true)
                      }}>Оставить отзыв ⭐</a>
                      <a href="#" onClick={(ev) => {
                        prevent(ev)
                        loyaltyStore.setPageTab(4)
                        store.setIsNotifyVisible(true)
                      }}>Правила бонусной программы</a>
                      <a target="_blank" href="https://твойплюс.рф/uploads/docs/01042026_Пользовательское_соглашение_TOPGUN_Plus_5_1.pdf">Пользовательское соглашение</a>
                      <a target="_blank" href="https://твойплюс.рф/uploads/docs/01042026_Special_Offers_1.pdf">Условия предоставления спец. предложений</a>
                    </div>
                  </div>
                  <div className="col-12 col-md-7">
                    <div className={styles.copys_links_r}>
                      <div className={styles.copys_links_r_w}>
                        <div className={styles.txt}>ООО "ИНДУСТРИЯ БАРБЕРИНГА", ИНН 7840093980, ул. Садовая, Д. 28_30, К. 15 Литер К15, ПОМЕЩ. 16-21Н ОФИС 1-10А, г. Санкт - Петербург. Тел. 8-800-200-44-20. Email info@твойплюс.рф. Все права защищены.</div>
                        <div className={styles.txt}>© ТВОЙПЛЮС  2014 — 2026</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
        
      <BlurModal
        visible={loyaltyStore.isPromoVisible}
        title=""
        onClose={() => loyaltyStore.setIsPromoVisible(false)}
        centered={true}
        content={<>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className={styles2.blurmodal_centered}>
                  <h3><b>Активировать <span>промокод</span></b></h3>
                
                  <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                      <div className={styles2.xcard}>
                        
                        <div className={styles3.form} id="form1" style={{opacity: 1}}>
                          <div className={styles3.form_field}>
                            <label className={styles3.form_field__label} htmlFor="name">Введите промокод</label>
                            <div className={styles3.form_field__input}>
                              {/* <input type="text" placeholder="****-****-****" /> */}
                              {/* <InputMask mask="****-****-****" maskChar="_" disabled={pcLoading} readOnly={pcLoading} style={{textTransform: "uppercase"}} placeholder="____-____-____" value={promocode} onChange={(event) => {
                                // console.log(event)
                                console.log(event.target.value)
                                setPromocode(prev => prev = event.target.value)
                              }} /> */}
                            </div>
                          </div>

                          <div className={styles3.form_actions} style={{
                            width: "100%", textAlign: "center", marginTop: "0px"
                          }}>
                            <button className={styles3.darked} onClick={() => pcLoading ? false : false}>{pcLoading ? <LoadingOutlined spin rev={null} /> : "Активировать"}</button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                
                </div>
              </div>
            </div>
          </div>
        </>} />

      <RulesModal />
      <ExcludedModal />
      <SupportModal />
      <MobileAppModal />
    </>
  )
}

export default observer(LoyaltyFooter)